import {
    READ_MESSAGE_START,
    READ_MESSAGE_SUCCESS,
    READ_MESSAGE_ERROR
} from '../../constants';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { readThread as mutation } from '../../lib/graphql';

export function readMessageAction({ bookingId }) {
    return async (dispatch, getState, { client }) => {
        try {
            if (!navigator.onLine) {
                showToaster({ messageId: 'networkFailed', toasterType: 'error' })
                return;
            }
            dispatch({
                type: READ_MESSAGE_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    bookingId:Number(bookingId)
                }
            });

            if (data?.readThread?.status === 200) {
                dispatch({
                    type: READ_MESSAGE_SUCCESS,
                });
            } else {
                dispatch({ type: READ_MESSAGE_ERROR });
            }
        } catch (error) {
            dispatch({
                type: READ_MESSAGE_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}